<template>
  <b-card class="mb-4 shadow ">
      <b-button
        v-if="!shown"
        @click="shown = true"
        class="stretched-link"
        variant="outline-secondary"
    >
          Show 3d preview
      </b-button>
    <b-embed 
        type="iframe" 
        :src="this.$api.previewURL(jobId)"
        v-if="shown"
    ></b-embed>
  </b-card>
</template>

<script>
import * as bs from 'bootstrap-vue';
import Vue from 'vue';

[
    bs.CardPlugin,
    bs.EmbedPlugin,
    bs.ButtonPlugin,
].forEach(p=> Vue.use(p))

export default {
  props: ["job-id"],
  data() {
    return {
      shown: false
    };
  },
  watch: {
            
      jobId(){this.shown = false;}
  },
};
</script>

<style>
</style>